var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartDischargeSummaryAppointmentDetailsCard_1;
import { Avatar, Card } from '@philips-internal/oswald-ui-components';
import { SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import MyChartDischargeSummaryCardAPI from './my-chart-discharge-summary-appointment-details-card-api';
import './my-chart-discharge-summary-appointment-details-card.css';
import calendar from '../../assets/images/global/calendar-black.svg';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let MyChartDischargeSummaryAppointmentDetailsCard = class MyChartDischargeSummaryAppointmentDetailsCard extends Component {
    static { MyChartDischargeSummaryAppointmentDetailsCard_1 = this; }
    static { this.propTypes = {
        uuid: string,
    }; }
    static { this.defaultProps = {
        width: 12,
    }; }
    render() {
        const { uuid, dateReport, timeReport, width = MyChartDischargeSummaryAppointmentDetailsCard_1.defaultProps.width } = this.props;
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.NONE, className: "my-chart-card-appointment-details-summary", width: width, transparent: true },
            React.createElement("div", { className: "card-content" },
                React.createElement("div", { className: "avatar-area avatar-area-doctor" },
                    React.createElement(Avatar, { title: MessageService.translate('tws.field-list-date-time'), image: calendar, size: Size.XSMALL }))),
            React.createElement("div", { className: "card-content area-tag" },
                React.createElement("div", { className: "avatar-area avatar-area-doctor" },
                    React.createElement(Avatar, { title: dateReport, subtitle: timeReport, hideImage: true })))));
    }
};
MyChartDischargeSummaryAppointmentDetailsCard = MyChartDischargeSummaryAppointmentDetailsCard_1 = __decorate([
    AwesomeComponent({ api: MyChartDischargeSummaryCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartDischargeSummaryAppointmentDetailsCard);
export default MyChartDischargeSummaryAppointmentDetailsCard;
//# sourceMappingURL=my-chart-discharge-summary-appointment-details-card.js.map